// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"103066ad","513":"2641cc96"}[chunkId] + ".chunk.js";
};